import { DashboardFilters } from "@/dashboard/types";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDashboardRankingsUsers } from "../../hooks/use-dashboard-rankings-users";
import { RankingsDataTable, type RankingsRow } from "../rankings-data-table";

interface DashboardRankingsUsersDataTableProps {
  filters: DashboardFilters;
}

export const DashboardRankingsUsersDataTable = ({
  filters,
}: DashboardRankingsUsersDataTableProps) => {
  const [t] = useTranslation(["dashboard"]);
  const { isLoading, top3RankingData, otherRankingData } =
    useDashboardRankingsUsers(filters);

  // O pódio (top 3) deixou de ser cards separados: o Figma mostra o ranking
  // inteiro numa tabela só, na ordem da API.
  const rows = useMemo<RankingsRow[]>(
    () => [...top3RankingData, ...otherRankingData],
    [top3RankingData, otherRankingData],
  );

  return (
    <RankingsDataTable
      data-testid="dashboard-rankings-users-table"
      rows={rows}
      isLoading={isLoading}
      nameHeader={t("dashboard-rankings-users-table-header-name") as string}
      emailHeader={t("dashboard-rankings-users-table-header-email") as string}
      valueHeader={t("dashboard-rankings-users-table-header-value") as string}
    />
  );
};
